export default __webpack_public_path__ + "static/media/DJI_0959.MP4.00_03_44_14.Still002.ef09c3af.jpg";